// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2QrhL","Open":"SideDrawer_Open__2te3R","Closed":"SideDrawer_Closed__KMNTe","Logo":"SideDrawer_Logo__1KAlO"};